package br.com.vvrefeicoes.portal.feature.auth.login

import androidx.compose.runtime.Composable

@Composable
fun LoginScreen(
    onForgotPassword: (String) -> Unit,
    showPasswordChangedBanner: Boolean = false,
) {
    val controller = rememberLoginController(onForgotPassword, showPasswordChangedBanner)
    LoginLayout(controller)
}
